var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_2925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1719 16.4452C51.2793 21.621 51.2793 29.9413 46.1719 35.1171L35.2344 46.1816C34.3262 47.0995 32.8418 47.1093 31.9238 46.2011C30.9961 45.2929 30.9961 43.8085 31.9043 42.8808L42.832 31.8261C46.1426 28.4765 46.1426 23.0859 42.832 19.7362L30.3613 7.11613C29.4434 6.19523 29.4531 4.71183 30.3809 3.80168C31.2988 2.89152 32.7832 2.90031 33.6035 3.82121L46.1719 16.4452ZM14.0625 13.9745C14.0625 15.7909 12.666 17.0995 10.9375 17.0995C9.21191 17.0995 7.8125 15.7909 7.8125 13.9745C7.8125 12.3339 9.21191 10.8495 10.9375 10.8495C12.666 10.8495 14.0625 12.3339 14.0625 13.9745ZM40.1074 21.3573C42.5488 23.7987 42.5488 27.7636 40.1074 30.205L27.0801 43.2324C24.6387 45.6738 20.6738 45.6738 18.2324 43.2324L1.83105 26.8261C0.658496 25.6542 0 24.0722 0 22.412V7.81242C0 5.22355 2.09863 3.12492 4.6875 3.12492H19.2871C20.9473 3.12492 22.5293 3.78312 23.7012 4.95597L40.1074 21.3573ZM4.6875 7.72453V22.412C4.6875 22.8222 4.85254 23.2226 5.14551 23.5155L21.5527 39.9218C22.1582 40.537 23.1543 40.537 23.7598 39.9218L36.7969 26.8847C37.4121 26.2792 37.4121 25.2831 36.7969 24.6777L20.3906 8.27043C20.0977 7.97746 19.6973 7.72453 19.2871 7.72453H4.6875Z",
    fill: "url(#paint0_linear_378_2925)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_2925",
    x1: -3.36151,
    y1: -15.2508,
    x2: 45.5411,
    y2: -6.90321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9075E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_2925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.b8bd5a17af9d182b47891cf66694f976.svg";
export { ForwardRef as ReactComponent };